import * as React from "react";
import { CSSTransition } from "react-transition-group";
import { getBackgroundColorClass } from "../../colors/index.mjs";
import { HashTrigger } from "../../hash-trigger/hash-trigger.mjs";
import { Heading } from "../../typography/heading/heading.mjs";
import { VisibilityProvider } from "../../helpers/visibility-provider/visibility-provider.mjs";
import { TabsContext } from "../tabs/tabs.mjs";
const TabsItem = (props) => {
  const { className, background, id, children, label } = props;
  const { currentTab, setCurrentTab, renderHiddenItems, headingLevel } = React.useContext(TabsContext);
  const isCurrent = id === currentTab;
  const BEM = () => {
    const classArray = ["tabs__item"];
    if (isCurrent) {
      classArray.push("is-current");
    }
    if (className) {
      classArray.push(className);
    }
    if (background) {
      classArray.push(getBackgroundColorClass(background));
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(VisibilityProvider, { isVisible: isCurrent }, /* @__PURE__ */ React.createElement(HashTrigger, { id, onMatch: () => setCurrentTab(id), renderWrapper: false }, /* @__PURE__ */ React.createElement(CSSTransition, { in: isCurrent, timeout: 300, classNames: "fade" }, /* @__PURE__ */ React.createElement("div", { className: BEM(), id, tabIndex: 0, role: "tabpanel", "aria-labelledby": "".concat(id, "-nav-item") }, label && /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "sr-only" }, label), renderHiddenItems ? children : isCurrent && children))));
};
export {
  TabsItem
};
